import Tooltip from 'bootstrap/js/dist/tooltip';

document.querySelectorAll('.tip').forEach((el) => {
  new Tooltip(el, {
    boundary: 'window'
  });
});